
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"82","height":"81","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M68.608 40.183H41.002V12.577l27.606 27.606z","fill":"url(#paint0_linear_15058_184964)"}}),_c('path',{attrs:{"d":"M13.396 40.182h27.606v27.606L13.396 40.182z","fill":"url(#paint1_linear_15058_184964)"}}),_c('path',{attrs:{"d":"M13.395 40.183H41V12.577L13.395 40.183z","fill":"url(#paint2_linear_15058_184964)"}}),_c('path',{attrs:{"d":"M68.608 40.183H41.002v27.605l27.606-27.605z","fill":"url(#paint3_linear_15058_184964)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_15058_184964","x1":"74.962","y1":"36.143","x2":"40.462","y2":"30.143","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".204","stop-color":"#8CDAE3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#56BFC7"}})]),_c('linearGradient',{attrs:{"id":"paint1_linear_15058_184964","x1":"27.462","y1":"70.143","x2":"29.462","y2":"35.143","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":".204","stop-color":"#8CDAE3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#56BFC7"}})]),_c('linearGradient',{attrs:{"id":"paint2_linear_15058_184964","x1":"41.961","y1":"42.143","x2":"2.64","y2":"14.512","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#DAF6FB"}}),_c('stop',{attrs:{"offset":".826","stop-color":"#8CDAE3"}})]),_c('linearGradient',{attrs:{"id":"paint3_linear_15058_184964","x1":"65.462","y1":"65.643","x2":"36.23","y2":"49.965","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#56BFC7"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#29757A"}})])])])
          )
        }
      }
    